(function() {
  'use strict';
  
  // Vérifier si le panier contient des produits Print Material
  function hasPrintMaterialProducts() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        return cart.items.some(item => item.product_type === 'Print Material');
      })
      .catch(() => false);
  }

  // Masquer et désactiver le widget SendCloud/Mondial Relay
  function hideRelayWidget() {
    hasPrintMaterialProducts().then(hasPrintMaterial => {
      if (hasPrintMaterial) {
        // Liste étendue de sélecteurs possibles
        const selectors = [
          '.sendcloud-service-point-selector',
          '#sendcloud-service-point-selector',
          '[data-sendcloud-widget]',
          '.service-point-selector',
          '[class*="sendcloud"]',
          '[id*="sendcloud"]',
          '[class*="mondial-relay"]',
          '[id*="mondial-relay"]',
          '[class*="relay"]',
          '[class*="pickup-point"]',
          'iframe[src*="sendcloud"]',
          'iframe[src*="mondialrelay"]'
        ];
        
        selectors.forEach(selector => {
          document.querySelectorAll(selector).forEach(element => {
            element.style.display = 'none !important';
            element.style.visibility = 'hidden !important';
            element.style.opacity = '0 !important';
            element.style.height = '0 !important';
            element.style.overflow = 'hidden !important';
            element.remove();
          });
        });
        
        // Bloquer aussi les options de livraison contenant "relay" ou "relais"
        document.querySelectorAll('input[type="radio"][name*="shipping"], label').forEach(element => {
          const text = element.textContent.toLowerCase();
          if (text.includes('relay') || text.includes('relais') || text.includes('mondial')) {
            const parent = element.closest('div, li, fieldset');
            if (parent) {
              parent.style.display = 'none !important';
              parent.remove();
            }
          }
        });
        
        console.log('✓ Mondial Relay masqué pour produits Print Material');
      }
    });
  }

  // Exécution multiple pour capturer tous les cas
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideRelayWidget);
  } else {
    hideRelayWidget();
  }
  
  // Réexécuter toutes les 500ms pendant 5 secondes
  let attempts = 0;
  const interval = setInterval(() => {
    hideRelayWidget();
    attempts++;
    if (attempts >= 10) clearInterval(interval);
  }, 500);
  
  // Observer les changements du DOM
  const observer = new MutationObserver(hideRelayWidget);
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    attributes: true 
  });
})();
